
import { useAuth } from "@/lib/auth";
import { useToast } from "@/hooks/use-toast";
import { useNavigate } from "react-router-dom";

export const useAuthGuard = () => {
  const { user } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();

  const ensureAuthenticated = () => {
    if (!user) {
      toast({
        title: "Authentication required",
        description: "Please log in to manage your resumes",
        variant: "destructive"
      });
      
      navigate("/auth/login");
      return false;
    }
    return true;
  };

  // Add a helper function to display API errors in a standard format
  const handleApiError = (error: any) => {
    console.error("API Error:", error);
    
    let errorMessage = "An unexpected error occurred";
    
    if (error.message) {
      errorMessage = error.message;
    } else if (typeof error === 'string') {
      errorMessage = error;
    } else if (error.error) {
      errorMessage = error.error;
    }
    
    toast({
      title: "Error",
      description: errorMessage,
      variant: "destructive"
    });
  };

  return {
    ensureAuthenticated,
    handleApiError,
    user
  };
};
